import React, { useEffect, useState } from "react";
import { FeatureFlagContext } from "./withFeatureFlags";
import { useCurrentUser } from "../../contexts/CurrentUserProvider";

const FeatureFlags = (
  /** @type {{children: React.ReactNode; }} */ props
) => {
  const currentUser = useCurrentUser();
  const [flags, setFlags] = useState(/** @type { string[] } */ ([]));

  useEffect(() => {
    const url = `/feature-flags?cb=${Date.now()}`;
    fetch(url, {
      method: "GET",
      headers:
        currentUser && currentUser.customerId
          ? { "X-FFID": currentUser.customerId }
          : {},
    })
      .then((response) => response.json())
      .then((data) => {
        setFlags(data || []);
      })
      .catch((error) => {
        console.error(`Error fetching feature flags for: ${url}`, error);
      });
  }, [currentUser]);

  return (
    <FeatureFlagContext.Provider value={flags}>
      {props.children}
    </FeatureFlagContext.Provider>
  );
};

export default FeatureFlags;
